<template>
<div>

<div class="table-responsive-sm mt-1">              
<table class="table table-bordered table-sm" id="labelPriceList">
    <thead class="thead-light">
    <tr>
        <th 
        
        class = "text-center"
        v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
         v-for="(key,index) in cols" :key="index">
           <!-- <small  v-if = "key !='Listino'" id="sizeHelp" class="form-text text-muted">Mis.</small>-->
            <span  v-if = "key !='Listino'" class="">{{key}}</span>
            <span  v-if = "key == 'Listino'" class="">

              <h4><strong>PREZZO E SCONTO ETICHETTA </strong></h4>
            </span>
        </th>
    </tr>
    </thead>
    <tbody>
      <tr v-for="(entry, index1) in items" :key="index1">
        <td v-for="(key,index2) in cols" :key="index2" >
            <div v-if="key != 'Listino'">
                
               <input  v-if="index1==0" min="0.01" step="0.01"  required  v-on:keydown="keyHandler($event,'Dec')" @input="$emit('update',updateItems())" v-bind:name="'id_' + index2 " v-model = "entry[key]" class="form-control inputClass"  type="number" placeholder="" >
               <input  v-else   required  v-on:keydown="keyHandler($event,'Num')" @input="$emit('update',updateItems())" v-bind:name="'id_' + index2 " v-model = "entry[key]" class="form-control inputClass"  type="number" placeholder="" >
            </div>
            <div v-else >

                <div v-if="index1==0">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">€</div>
                  </div>

                  <input  min="0.01" step="0.01"  v-focus class="form-control"  v-bind:name="entry['Listino']" type="number" v-bind:placeholder="entry['Listino']">
                   <div class="input-group-append">
                    <span data-toggle="tooltip" data-placement="bottom" title="ripeti per ogni colonna" class="input-group-text pointer" @click="repeatPrice(index1)" style=''><i class='fas fa-clone mr-2'></i></span>
                  </div>
                  
                  
                </div>

                 <small  v-if="err[0] == 1 && index1==0" style="color:red"  class="float-right mr-4"><strong>Compila il campo</strong> </small> 
                </div> 
                <div v-else>  
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">%</div>
                  </div>

                  <input :value="0" class="form-control"  v-bind:name="entry['Listino']" type="number" v-bind:placeholder="entry['Listino']">
                  <div class="input-group-append">
                    <span data-toggle="tooltip" data-placement="bottom" title="ripeti per ogni colonna" class="input-group-text pointer" @click="repeatPrice(index1)" style=''><i class='fas fa-clone mr-2'></i></span>
                  </div>
                </div>
                 <small  v-if="err[1] == 1 " style="color:red"  class="float-right mr-4"><strong>Compila il campo</strong> </small> 
                </div>
                
          </div>
        </td>
      </tr>
    </tbody>
</table>

<alert-box class="mt-1 mb-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

 </div>
</div> 
</template>

<script>

import alertBox         from '@/components/common/AlertBox.vue';
import keyHandler       from '@/components/mixins/keyHandler'
//import keyHandlerEuro   from '@/components/mixins/keyHandlerEuro'

import { mapGetters }       from 'vuex';
export default {
  
  mixins: [keyHandler],
  
  components: {alertBox},  
  props: ['product'],
  data () {
  
    return {
     
     err            : [],
     cols           : [],
     items          : [],
     label          : [], 
     spinner        : false,

      
     msg     : {
       title : '',
       body  : '',
       type  : 0
     },
    

    }
  },
  

  
   directives: 
    {
      focus: {

      inserted: function (el) 
      {
        if(el.name=='label_price')
        {
         el.focus() 
        }
      }
      }
    },
  mounted()
    {
      //$('input:visible:enabled:first').focus();  
    },
  created()
  {

   
   this.createItems()

   this.$nextTick(function () {
        this.$emit('update',this.updateItems())
   
      })
   

  },

  methods: 
  {
  
  
    formatEuro(v)
    {
      var formatter = new Intl.NumberFormat('de-DE', {
      //style      : 'currency',
      minimumFractionDigits : 2, 
      maximumFractionDigits : 2,
      currency              : 'EUR',
    });

      return formatter.format(v); 
    },
  
    createItems()
      {
      
        
        this.cols    = []
        this.items   = []
        
        var cols  = this.product.sizes

        this.cols.push('Listino')  

        cols.forEach(item =>
        {
          this.cols.push(item.size)
        })

        

        var obj = {'Listino':'Prezzo'}

        cols.forEach(item =>
        {
          obj[item.size] = item.price; 
          
        })

        this.items.push(obj)

        var obj = {'Listino':'Sconto'}
        
        cols.forEach(item =>
        {        
          obj[item.size] = item.discount; 
          
        })
        
         
        this.items.push(obj)
       
        


      },

      repeatPrice(index)
      {
        var label_price     = document.getElementsByName("Prezzo")[0].value
        var label_discount  = document.getElementsByName("Sconto")[0].value
        
        this.err = []
        
        
        
        if(index == 0)
        {
          if(Number(label_price) == 0)
          {
            label_price = 0
            /*
            document.getElementsByName("Prezzo")[0].focus()
            this.err.push(1) 
            return
            */

          }
        }

        if(index == 1)
        {
        if(Number(label_discount) == 0)
        {

          /*
          document.getElementsByName("Sconto")[0].focus()
          this.err.push(0)
          this.err.push(1)

          return
          */
        }
        }

        
        /*
        if(index==0)
        {
          if(this.formatEuro(label_price)=='0,00')
          {
              this.msg.title = 'Prezzo di vendita base  non valido.'
              this.msg.body = ''
              this.msg.type = 1
              
              return     
          }
        }
        */
        /* 
        if(index == 1)
        {
          if(label_discount == '')
          {
              this.msg.title = 'Sconto base non valido.'
              this.msg.body = ''
              this.msg.type = 1
              
              return     
          }
        }
        */
        if(index==0)
        {
          this.cols.forEach(col =>
          {              
            if (col != 'Listino')
            {
              this.items[0][col] = parseFloat(label_price).toFixed(2)   
            }    
          })
        }
        else
        {
          this.cols.forEach(col =>
          {  
            if (col != 'Listino')
            {
              if(Number(label_discount)== 0)
              {
                this.items[1][col] = 0  
              }
              else
              {
                this.items[1][col] = parseInt(label_discount)
              }
            }
          })

        }

        this.$emit('update',this.updateItems())
      },


      
      updateItems()
      {
        this.label = []
        
        //console.log('sizes',this.product.sizes)

        this.product.sizes.forEach(item=>{
            this.label.push({'size':item.size,'sizeId':item.sizeId,'price':item.price,'discount':item.discount})
        })

        


        const updateArr = (key,value,row_type) =>
        {
          this.label.forEach(item =>
          {
            // PREZZO
            if(row_type == 'Prezzo')
            {
              if(item.size == key)
              {
                item.price    = value
                
              }
            }

            // SCONTO
            if(row_type == 'Sconto')
            {
              if(item.size == key)
              {
                item.discount = parseInt(value)
              }
            }

          })
        }
        this.items.forEach(e =>{
          var row_type = e.Listino
          
          

          Object.entries(e).forEach(item => {
                      let key   = item[0]
                      let value = item[1]
                      //use key and value here
                      if (key != 'Listino')
                      {
                        updateArr(key,value,row_type)
                        
                      }
          })
        })
      

      return this.label
      

     
      },
      
      
  }
  
}
</script>

<style scoped>
.inputClass{
  font-weight       : bold;
}

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 14px;
  color        : black;
}
.btn-link {
  font-family  : 'Roboto Condensed';
  font-size    : 12px;
}
.form-control{
  font-family  : 'Roboto Condensed';
  font-size    : 12px;
}
.fa-clone
{
  color:darkgreen;;
}
.pointer{
  cursor: pointer;
}
</style>